import { render, staticRenderFns } from "./DlgResult.vue?vue&type=template&id=1345f008&scoped=true"
import script from "./DlgResult.vue?vue&type=script&lang=js"
export * from "./DlgResult.vue?vue&type=script&lang=js"
import style0 from "./DlgResult.vue?vue&type=style&index=0&id=1345f008&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1345f008",
  null
  
)

export default component.exports